export default __webpack_public_path__ + "static/media/paintings_btn.e59f6762.jpg";